module.exports = __webpack_public_path__ + "static/media/meditate5.a1deca81.jpg";